import React from 'react';
import { Card, Col, Form, InputNumber, Modal, Row, Select, Button } from "antd";
import { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import CmdService from "../app/service/cmdService";
import PlateService from "../app/service/plateService";
import RouteService from "../app/service/routeService";
import { LinksTable } from "../components/linkRoute/linksTable";
import { messageError, messageSuccess, messageAlert } from "../components/toastr";
import AuthContext from "../main/authenticationProvider";
import { DownloadOutlined, CloseOutlined } from '@ant-design/icons';


const LinkRoute = ({ nameRota, idRoute, linkRoutePlate, closeCard }) => {
    const INITIAL_TIMER = 60;
    const DEFAULT_VALUE_CRITERIO = 250;
    const serviceRoute = new RouteService();
    const servicePlate = new PlateService();
    const serviceCmd = new CmdService();
    const auth = new AuthContext();

    const [routes, setRoutes] = useState([]);
    const [routeSelected, setRouteSelected] = useState("");
    const [routeSelectedName, setRouteSelectedName] = useState("");
    const [plates, setPlates] = useState([]);
    const [links, setLinks] = useState([]);
    const linksVerify = useRef();
    const [plateSelected, setPlateSelected] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingLinks, setLoadingLinks] = useState(false);
    const [timer, setTimer] = useState(INITIAL_TIMER);
    const firstUpdate = useRef(true);
    const [formLinkRoute] = Form.useForm();
    const [downloadLinkFinished, setDownloadLinkFinished] = useState(false);

    const getRoutes = () => {
        serviceRoute
            .getRoutes()
            .then((response) => {
                let opt = [];
                response.data.data.forEach(item => {
                    opt.push({
                        value: item.routeId,
                        label: item.name
                    });
                });

                setRoutes(opt);
            })
            .catch(erros => {
                erros && erros.response && auth.verifyAuth();
            })
    };

    const getPlates = () => {
        servicePlate
            .getPlates()
            .then(response => {
                let opt = [];
                response.data.data.forEach(item => {
                    opt.push({
                        value: item.plate,
                        label: item.plate,
                        disabled: item.roteirizadorHabilitado
                    });
                });
                setPlates(opt);
            })
            .catch(erros => {
                erros && erros.response && auth.verifyAuth();
            })
    };

    const getLinks = (plate) => {

        setLoadingLinks(true);
        const plateTest = plate === undefined ? plateSelected : plate;
        try {
            servicePlate.getStatusRoutePlate(plateTest).then(
                response => {

                    let infoRoutePlate = [];
                    infoRoutePlate[0] = {
                        "plate": response.data.data.plate,
                        "plateIdUuid": response.data.data.plateIdUuid,
                        "qtyPages": response.data.data.qtyPages,
                        "qtyPagesReceived": response.data.data.qtyPagesReceived,
                        "routeDownloadAttempts": response.data.data.routeDownloadAttempts,
                        "routeLoadDate": response.data.data.routeLoadDate,
                        "routeLoadStatus": response.data.data.routeLoadStatus,
                        "routeStartStatus": response.data.data.routeStartStatus,
                        "routeName": response.data.data.routeName,
                        "startDate": response.data.data.startDate,
                    }
                    linksVerify.current = infoRoutePlate;

                    let promises = [
                        serviceCmd.getStatusPlate(plateTest)
                            .then((response) => {
                                const roteirizador =
                                    response.data.data.roteirizador &&
                                        response.data.data.roteirizador.substring(0, 1) === "0"
                                        ? "Desabilitado"
                                        : "Habilitado";
                                const devicesEnable = response.data.data.devicesHabilitado.substring(0, 1) === "0" ? "Não" : "Sim";
                                const newData = {
                                    "plate": infoRoutePlate[0].plate,
                                    "plateIdUuid": infoRoutePlate[0].plateIdUuid,
                                    "qtyPages": infoRoutePlate[0].qtyPages,
                                    "qtyPagesReceived": infoRoutePlate[0].qtyPagesReceived,
                                    "routeDownloadAttempts": infoRoutePlate[0].routeDownloadAttempts,
                                    "routeLoadDate": infoRoutePlate[0].routeLoadDate,
                                    "routeLoadStatus": infoRoutePlate[0].routeLoadStatus,
                                    "routeStartStatus": infoRoutePlate[0].routeStartStatus,
                                    "routeName": infoRoutePlate[0].routeName,
                                    "startDate": infoRoutePlate[0].startDate,
                                    "roteirizador": roteirizador,
                                    "devicesEnable": devicesEnable,
                                };
                                return { key: 0, element: newData };
                            })
                            .catch((erros) => {
                                if (erros && erros.response) {
                                    auth.verifyAuth(erros.response.status);
                                }
                                return null;
                            })
                    ];
                    Promise.all(promises).then((results) => {
                        const finalList = results.filter((result) => result !== null);
                        setLinks(finalList);
                        setLoadingLinks(false);
                    }).catch(error => {
                        setLoadingLinks(false);
                    });
                    setLoadingLinks(false);
                }
            ).catch(error => {
                error && error.response && auth.verifyAuth();
                setLoadingLinks(false);
            });
        } catch (error) {
            console.error("Error", error)
        }

    };

    const saveLinkOffline = (values) => {
        setLoading(true);
        serviceCmd
            .loadroute({
                "routeId": values.route === undefined ? (idRoute !== null ? idRoute : values.route) : values.route,
                "plate": values.plate,
                "criterio": values.criterio ?? DEFAULT_VALUE_CRITERIO
            }).then((response) => {
                if (response.data.status !== 200) {
                    messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
                } else {
                    messageSuccess("Comando transmitido. Aguarde a conclusão do processo de download da rota no dispositivo.");
                    getLinks();
                    setLoading(false);
                    linkRoutePlate(true, plateSelected);
                    setDownloadLinkFinished(true);
                }
            }).catch((error) => {
                setLoading(false);
                if (error.response.data.status === 400) {
                    messageError(error.response.data.message);
                } else if (error.response.data.status === 406) {
                    messageAlert("ATENÇÃO!" + error.response.data.message);
                } else if (error.response.data.status === 413) {
                    messageAlert("ATENÇÃO! Rota inválida. Quantidade de páginas superior a 71.");
                } else {
                    messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
                }
            });
    };

    const checkLink = (data) => {

        const dataSave = {
            "plate": data.plate,
            "criterio": data.criterio,
            "rota": routeSelected,
        }


        let checkFilter = [];
        if (linksVerify.current != undefined) {
            checkFilter = linksVerify.current.filter(link => link.plate === dataSave.plate);
        }

        if (checkFilter.length > 0) {
            if (checkFilter[0].routeLoadStatus !== "CONCLUDED") {
                Modal.confirm({
                    title: 'ATENÇÃO! Placa em processo de vinculação com a rota (' + checkFilter[0].routeName + ') no momento.',
                    content: 'Deseja realmente abortar o vínculo em andamento e iniciar um novo?',
                    okText: 'Confirmar',
                    cancelText: 'Cancelar',
                    onOk() {
                        saveLinkOffline(dataSave);
                    },
                    onCancel() {
                        setLoading(false);
                    },
                    width: 500
                });
            } else {
                if (checkFilter[0].routeStartStatus === "STARTED") {
                    Modal.confirm({
                        title: 'ATENÇÃO! Este dispositivo encontra-se com roteirização em curso, e esta ação cancelará tal processo.',
                        content: 'Deseja realmente prosseguir?',
                        okText: 'Confirmar',
                        cancelText: 'Cancelar',
                        onOk() {
                            saveLinkOffline(dataSave);
                        },
                        onCancel() {
                            setLoading(false);
                        },
                        width: 500
                    });
                } else {
                    if (routeSelectedName === checkFilter[0].routeName) {
                        Modal.confirm({
                            title: 'Placa atual já está vinculada a rota (' + checkFilter[0].routeName + ').',
                            content: 'Deseja vincular a placa a está rota mesmo assim ?',
                            okText: 'Confirmar',
                            cancelText: 'Cancelar',
                            onOk() {
                                saveLinkOffline(dataSave);
                            },
                            onCancel() {
                                setLoading(false);
                            },
                            width: 500
                        });

                    }
                    else {
                        Modal.confirm({
                            title: 'Placa vinculada à outra rota.',
                            content: 'ATENÇÃO! Esta placa encontra-se vinculada à rota (' + checkFilter[0].routeName + ') no momento. Deseja realmente excluir o vínculo atual e criar um novo?',
                            okText: 'Confirmar',
                            cancelText: 'Cancelar',
                            onOk() {
                                saveLinkOffline(dataSave);
                            },
                            onCancel() {
                                setLoading(false);
                            },
                            width: 500
                        });
                    }
                }

            }


        } else {
            saveLinkOffline(dataSave);
        }
    };

    const handleCloseCard = () => {
        closeCard();

    }
    useEffect(() => {
        let interval = null;

        if (firstUpdate.current) {

            firstUpdate.current = false;
            getRoutes();
            getPlates();
            if (nameRota !== "") {
                setRouteSelected(idRoute);
                setRouteSelectedName(nameRota);
            }
        }



        if (timer >= 0) {
            interval = setInterval(() => setTimer(timer => timer - 1), 1000);
        } else {
            clearInterval(interval);
            setTimer(INITIAL_TIMER);
            getLinks();
        }
        return () => clearInterval(interval);
    }, [timer]);

    return (
        <Card title="Vincular Rota" style={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5, height: '300px' }} extra={<Button
            type="text"
            shape="circle"
            icon={<CloseOutlined style={{}} />}
            onClick={handleCloseCard}>
        </Button>}>
            <Form
                onFinish={(values) => checkLink(values)}
                form={formLinkRoute}
                layout='vertical'
                style={{ height: 50 }}
            >
                <Row>
                    <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                        <Form.Item name="plate" required rules={[{ required: true, message: 'Selecione uma placa.' }]} label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Placas</b>} tooltip='Apenas placas com o sistema e roteirizador habilitados poderão ser selecionadas.'>
                            <Select
                                showSearch
                                filterOption={(input, option) =>
                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                }
                                onChange={(plate) => {
                                    getLinks(plate)
                                    setPlateSelected(plate)
                                }}
                                placeholder="Placas"
                                allowClear
                                options={plates ? plates : null}
                                style={{ width: '85%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                        <Form.Item name="criterio" required label={<b style={{ fontSize: '15px', fontWeight: 500 }}>Critério</b>} initialValue={DEFAULT_VALUE_CRITERIO}>
                            <InputNumber
                                className='custom-inputNumber'
                                min={50}
                                max={950}
                                step={50}
                                formatter={value => `${value} m`}
                                parser={value => value.replace('m', '')}
                                style={{ width: '85%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6} style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                        <Button
                            block
                            loading={loading}
                            type='primary'
                            icon={<DownloadOutlined />}
                            htmlType="submit"
                            style={{ backgroundColor: '#246192', float: 'left' }}
                            children='Vincular'
                        />
                    </Col>

                </Row>
            </Form>
            {downloadLinkFinished ?
                <LinksTable links={links} loading={loadingLinks} servicePlate={servicePlate} getLinks={getLinks} />
                :
                <></>
            }

        </Card>
    );
}

export default withRouter(LinkRoute);